'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bomb';
var width = 512;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M16 304c0 106 86 192 192 192s192-86 192-192c0-25.1-4.8-49-13.5-70.9-1.2-3-.5-6.4 1.8-8.6L407 205.7c.6-.6 1.1-1.3 1.5-2.1-.9-4.1-2.9-7.9-6.1-11.1L320 109.9c-3.7-3.7-8.4-5.9-13.3-6.4-.2 .2-.5 .4-.7 .6l-21.1 19c-2.2 2-5.4 2.6-8.2 1.5-21.3-8.2-44.5-12.7-68.7-12.7-106 0-192 86-192 192zm48 0c0-79.5 64.5-144 144-144 4.4 0 8 3.6 8 8s-3.6 8-8 8c-70.7 0-128 57.3-128 128 0 4.4-3.6 8-8 8s-8-3.6-8-8z', 'M448 8c4.4 0 8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0 0-40c0-4.4 3.6-8 8-8zM295.4 92.2c9.5-8.5 24-8.2 33 .9l39.6 39.6 26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-26.3 26.3 39 39c9.4 9.4 9.4 24.6 0 33.9l-15.1 15.1c8.3 22.4 12.8 46.6 12.8 71.9 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c24.5 0 48 4.2 69.8 12l17.6-15.8zm21.7 12.2c-3-3-7.8-3.1-11-.3l-21.1 19c-2.2 2-5.4 2.6-8.2 1.5-21.3-8.2-44.5-12.7-68.7-12.7-106 0-192 86-192 192s86 192 192 192 192-86 192-192c0-25.1-4.8-49-13.5-70.9-1.2-3-.5-6.4 1.8-8.6L407 205.7c3.1-3.1 3.1-8.2 0-11.3l-90-90zM80 304c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-79.5 64.5-144 144-144 4.4 0 8 3.6 8 8s-3.6 8-8 8c-70.7 0-128 57.3-128 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;